import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-gemstone-template-info',
  imports: [TranslatePipe],
  templateUrl: './gemstone-template-info.component.html',
  styleUrls: [
    './gemstone-template-info.component.scss',
    '../template-shared.stylesheet.scss',
  ],
})
export class GemstoneTemplateInfoComponent {
  translationPrefix = input('', { transform: appendPrefix });
}
function appendPrefix(value: string | undefined): string {
  return value + 'gemstone.';
}
